import { DateTime } from "luxon";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { DoubleShift } from "../../../types/Shift";
import { ErrorResponse } from "../../../DTOs/Common/ErrorResponse";
import { setShiftEditability } from "../../../state/reducers/shiftReducer";
import { settingsAjax } from "../../../ajax/SettingsAjax";
import { useGlobalModal } from "../../Contexts/GlobalModalContext";
import { useSnackbar } from "notistack";

type ShiftLockStatusChangeModalProps = {
  isCurrentlyLocked: boolean
  selectedDate: DateTime;
  selectedShift: DoubleShift;
};

const ShiftLockStatusChangeModal: React.FC<ShiftLockStatusChangeModalProps> = ({
  isCurrentlyLocked,
  selectedDate,
  selectedShift
}) => {
  const { hideModal } = useGlobalModal();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const handleConfirm = useCallback(async () => {
    const selectedShiftChar = selectedShift[0] as "D" | "N";
    let res;

    if (isCurrentlyLocked)
      res = await settingsAjax.unlockShift(selectedDate, selectedShiftChar);
    else
      res = await settingsAjax.relockShift(selectedDate, selectedShiftChar);

    if (!ErrorResponse.isErrorResponse(res) && res.data) {
      dispatch(setShiftEditability(res.data));
      hideModal();
    }
    else
      enqueueSnackbar("Failed to fetch shift editability", { variant: "error" });
  }, [dispatch, hideModal, isCurrentlyLocked, selectedDate, selectedShift, enqueueSnackbar])

  return (
    <>
      <h2 className="text-2xl font-semibold mb-4 text-theme-text">{isCurrentlyLocked ? "Unlock Shift?" : "Lock Shift?"}</h2>
      <p className="mb-4 text-theme-text">
        {isCurrentlyLocked
          ? "This will allow you and other users to edit data for this shift."
          : "This will prevent you and other users from editing data for this shift."}
      </p>
      <div className="flex justify-end gap-2 mt-12">
        <button type="button" onClick={hideModal} className="px-4 py-2 bg-theme-text-muted text-white hover:bg-theme-text-muted-hover hover:text-theme-text-hover transition rounded-sm border-none cursor-pointer">
          Cancel
        </button>
        <button
          type="button"
          onClick={handleConfirm}
          className="px-4 py-2 rounded bg-theme-info text-white hover:bg-theme-info-hover transition rounded-sm border-none cursor-pointer"
        >
          {isCurrentlyLocked ? "Unlock" : "Lock"}
        </button>
      </div>
    </>
  )
};

export default ShiftLockStatusChangeModal;